import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {bindActionCreators} from 'redux';
import * as headerActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as footerActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';

// Helpers
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import PageTracker from 'app-lib/helpers/page-tracker';

export class NoSearchResults extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.initHeader({
            navbarBackgroundClasses: 'homepage--nav-background',
            menuItemTextClasses: 'homepage-header-menu-item-text',
            showAlternateLogo: true,
            showSearch: true,
            searchQuery: this.props.searchQuery
        });
        this.props.initFooter({
            isActive: true,
            classes: 'generic-page-footer',
            left: <span>{this.props.t('channel.footer.powered')}</span>,
            right: [
                <span id="terms&conditions" key="terms&conditions">
                    <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                        {this.props.t('channel.footer.tnc')}
                    </a>
                </span>,
                <span key="privacy">
                    <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                        {this.props.t('channel.footer.privacy')}
                    </a>
                </span>,
                <span key="rights">
                    {this.props.t('channel.footer.copyright')} {this.props.t('channel.footer.company')}
                </span>
            ]
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.searchId && nextProps.searchQuery) {
            this.mixPanelSearch(nextProps.searchId, nextProps.searchQuery);
        }
    }

    componentWillUnmount() {
        this.props.initHeader();
        this.props.initFooter();
    }

    mixPanelSearch(searchId, searchQuery) {
        if (searchId && searchQuery) {
            mixpanelTracker.track(`${mixpanelTracker.searchPage}-${mixpanelTracker.noSearchResults}`, {
                search_id: searchId,
                query: searchQuery,
                page: PageTracker.lastPage,
                results_quantity: 0
            });
        }
    }

    displayNoSearchResults() {
        const {t} = this.props;
        return (
            <div className="not-found--container">
                <div className="not-found-img--container">
                    <img src={`${config.assets.url}/images/search/results-not-found-bot.svg`} alt="No Results Found" />
                </div>
                <div className="not-found-p1--container">{t('search.noContentFound')}
                    "{this.props.searchQuery}"
                </div>
                <div className="not-found-p2--container">
                    {t('search.tryAnotherSearch.p1')}
                    <a href={`${config.app.baseUrl}`}>{this.props.t('search.tryAnotherSearch.p2')}</a>
                    {t('search.tryAnotherSearch.p3')}
                </div>
            </div>
        );
    }
    displaySearchError() {
        const {t} = this.props;
        return (
            <div className="not-found--container">
                <div className="not-found-img--container">
                    <img src={`${config.assets.url}/images/search/results-not-found-bot.svg`} alt="No Results Found" />
                </div>
                <div className="not-found-p1--container">
                    {t('internalServer.something')}
                </div>
                <div className="not-found-p2--container">
                    {t('internalServer.fix')}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
            {this.props.isSearchError ? this.displaySearchError() : this.displayNoSearchResults()}
            </div>
        );
    }
}

NoSearchResults.propTypes = {
    searchQuery: PropTypes.string,
    searchId: PropTypes.string,
    t: PropTypes.func,
    initHeader: PropTypes.func,
    initFooter: PropTypes.func,
    isSearchError: PropTypes.bool
};

NoSearchResults.defaultProps = {
    isSearchError: false
};

export default connect(undefined, dispatch => bindActionCreators(Object.assign({}, headerActions, footerActions), dispatch))(translate(['translation'])(NoSearchResults));



// WEBPACK FOOTER //
// ./src/components/search/no-search-results.js